import type { IProduct } from '@inter-ikea-kompis/types';
import { ProductUtility } from '@inter-ikea-kompis/utilities';

const INJURY_OR_DEATH_WARNING_CODE = 'US_acknowledgement_product_list';

export default class InjuryOrDeathWarningUtility {
	public static anyProductHasWarning(products: IProduct[], includedProducts: IProduct[]): boolean {
		const flattened = this.flattenProducts(products, includedProducts);
		return flattened.some((product) => this.productHasWarning(product));
	}

	private static productHasWarning(product: IProduct): boolean {
		return (
			product.content?.complianceInformation?.some(
				(info) => info.datasetCode === INJURY_OR_DEATH_WARNING_CODE
			) ?? false
		);
	}

	/**
	 * Returns a flat list of products and their children.
	 */
	private static flattenProducts(products: IProduct[], includedProducts: IProduct[]): IProduct[] {
		return products.flatMap((product) => {
			const includedShoppingProducts = ProductUtility.getIncludedShoppingProducts({
				product,
				includedProducts,
				ignoreInvalidProducts: false
			});

			const childProducts = includedShoppingProducts.map(
				(shoppingProduct) => shoppingProduct.product
			);

			return [product, ...childProducts];
		});
	}
}
